import { Button as AntdButton, ButtonProps } from "antd"
import React from "react"
import styled from "styled-components"

interface IButton extends ButtonProps {
  buttonType?: "primary" | "border-gradient" | "default" | "secondary"
  iconAlignment?: "left" | "right"
  width?: string
}
const StyledButton = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: none;
  height: 49px;
  padding: 10.5px 24px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.btnSecondaryColor};
  flex-direction: ${(props: IButton) =>
    props.iconAlignment === "right" ? "row-reverse" : "row"};
  color: ${(props) => props.theme.buttonTextColor};
`
const StyledPrimaryLargeButton = styled(StyledButton)`
  background: ${(props) => props.theme.buttonColor} !important;
  color: ${(props) => props.theme.buttonTextColor} !important;
  padding: 16px 25px;
  width: 240px;
  height: 59px;
  &:hover,
  &:active {
    background-image: ${(props) => props.theme.hoveButtonGradient};
  }
`

const StyledSecondaryButton = styled(StyledButton)`
  width: ${(props: IButton) => (props.width ? props.width : "226px")};
  color: ${(props) => props.theme.base};
  height: 50px;
  background: ${(props) => props.theme.highlightGradient};
`

export const UserButton: React.FC<IButton> = (props) => {
  const { buttonType, ...rest } = props
  switch (buttonType) {
    case "primary":
      return <StyledPrimaryLargeButton {...rest} />
    case "secondary":
      return <StyledSecondaryButton {...rest} />
    default:
      return <StyledButton {...rest} />
  }
}
